import classes from "./Transactionbrowse.module.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TextFieldForm from "../../../../../components/common/textFieldForm";
import { Box, Grid, Tooltip } from "@mui/material";
import { useForm } from "react-hook-form";
import MUIDataTable from "mui-datatables";
import DatePickerForm from "../../../../../components/common/datePickerForm";
import { postApiData } from "../../../../../components/utilities/nodeApiServices";
import {
    ShankarSirUrl,
    ShankarSirUrlServer,
    apiList,
} from "../../../../../components/utilities/nodeApiList";
import { useContext } from "react";
import { AuthContext } from "../../../../../context/AuthContext";
import { useEffect } from "react";
import { styled, Button } from "@mui/material";
import AutocompleteForm from "../../../../../components/common/autuCompleteForm";
import { errorMessages } from "../../../../../components/utilities/formValidation";
import Loader from "../../../../../components/common/loader";
import { compareTextAndReturnObject } from "../../../../../components/common/commonArray";
import SweetAlertPopup from "../../../../../components/common/sweetAlertPopup";
import { useDispatch, useSelector } from 'react-redux';
import { logout } from "../../../../../store/authSlice";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { convertDate } from "../../../../../components/utilities/convertDate";
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import GridTablePagination from "../../../../../components/common/gridTablePagination";
import { jsPDF } from "jspdf";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import maheshbanklogo from "../../../../../assets/Banks/BuddhaAkshay/images/Logo.svg";
import { motion } from "framer-motion";
import CachedIcon from '@mui/icons-material/Cached';
import FilterImg from "../../../../../assets/Funnel.svg"
import TxnFilterModal from "./TxnFilterModal";
import TransactionReceiptModal from "./Receipt/TransactionReceipt";
import TransactionReceipt from "./Receipt/TransactionReceipt";
import { numberCommaFormat } from "../../../../../components/utilities/fileUploadHelper";


const defaultFilterData = {
    accNo: "",
    fromDt: "",
    toDt: "",
};

const TransactionBrowse = () => {
//   const [filterData, setFilterData] = useState(defaultFilterData);



    const navigate = useNavigate();
    //   const { state: user } = useContext(AuthContext);
    const [username, setUserName] = useState("");
    const [token, setToken] = useState("");
    const { loading, error, isAuthenticated, menu, userRole, sessionId, user } = useSelector((state) => state.auth);
    const [isLoading, setIsloading] = useState(false)
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [data, setData] = useState("");
    const [initialLoad, setInitialLoad] = useState(true);
    const [payloadData, setPayloadData] = useState({});
    const [responseData, setResponseData] = useState({});
    const [totalRecord, settotalRecord] = useState(0);
    const [goPageNumber, setGoPageNumber] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedRows, setSelectedRows] = useState([]);
    const [rowDataToDisplay, setRowDataToDisplay] = useState({});
    const [tableHeaders, setTableHeaders] = useState([]);
    const [bankNamee, setbankNamee] = useState("");
    const [message, setMessage] = useState("");
    const [atmMasterList, setAtmMasterList] = useState([]);
const [receiptData, setReceiptData] = useState([]);
    const [logoBase64, setLogoBase64] = useState(null);
     const [selectedAccountName, setSelectedAccountName] = useState("");
     const theme = useSelector((state) => state.theme.theme);
//   const handleReset = () => {
//     setFilterData(defaultFilterData);
//   };
const [filterData,setFilterData]=useState([]);

    useEffect(() => {
        // Convert logo SVG to base64 using a simple method
        const logo = new Image();
        logo.src = maheshbanklogo;
        logo.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = logo.width;
            canvas.height = logo.height;
            ctx.drawImage(logo, 0, 0);
            setLogoBase64(canvas.toDataURL("image/png")); // Store base64 data
        };
    }, []);

        const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

          const [isModalOpenReciept, setIsModalOpenReciept] = useState(false);

  const openModalReciept = (responseData) => {
    setResponseData(responseData)
    setIsModalOpenReciept(true);
  };

  const closeModalReciept = () => {
    setIsModalOpenReciept(false);
  };

        const [showFilters, setShowFilters] = useState(false);
  const toggleFilters = () => {
    setShowFilters((prevState) => !prevState);
  };

  const handleReset = () => {
    setFilterData(defaultFilterData);
};
    const handleToggle = () => {
    toggleFilters();
    handleReset();
    // fetchData();
  };
 
    const allOption = {
        code: "",
        value: "All"
    };

    const banksCode = [{
        code: "",
        value: "All"
    }]

    const TransactionType = [
        {
            code: "",
            value: "All"
        },
        // {
        //   code: "IMPS",
        //   value: "IMPS"
        // },
        {
            code: "RTGS",
            value: "RTGS"
        },
        {
            code: "NEFT",
            value: "NEFT"
        },
        {
            code: "INTERNAL",
            value: "WITHIN BANK",
        },
    ]

    const ResponseCode = [
        {
            code: "",
            value: "All"
        },
        {
            code: "S",
            value: "Success"
        },
        {
            code: "F",
            value: "Failed"
        },
    ]

    const Status = [
        {
            code: "",
            value: "All"
        },
        {
            code: "SUCCESS",
            value: "Success"
        },
        {
            code: "FAILURE",
            value: "Fail"
        },
    ]
    // useEffect(() => {
    //     if ((initialLoad && Status.length > 0)) {
    //         setValue(
    //             "transstatus",
    //             Status
    //                 ? compareTextAndReturnObject(Status, Status[0]?.value)
    //                 : ""
    //         );
    //         setInitialLoad(false);
    //     }
    // }, [initialLoad, Status]);

    const openModal = (rowData) => {

        console.log("rowData", rowData)

        var modifiedRowData = [...rowData];
        modifiedRowData[2] = rowData[2] == "INTERNAL" ? "WITHIN BANK" : rowData[2];
        const headers = columns && columns
            ?.filter(
                (column) => column?.label !== "View"
            )
            .map((column) => column?.label);
        setTableHeaders(headers);
        setRowDataToDisplay({
            headers: headers,
            rowData: modifiedRowData,
        });
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };
    console.log("atmMasterList", atmMasterList)
    const handleNavigate = (route, rowData ,selectedAccountName) => {
        navigate(route, { state: { rowData: rowData , selectedAccountName : selectedAccountName } });
      };


      console.log("selectedAccountName",selectedAccountName)
    const columns = [
        // {
        //     name: "View",
        //     label: "Receipt",
        //     options: {
        //         filter: true,
        //         sort: false,
        //         customBodyRender: (value, { rowData }, tableMeta) => {
        //             return (
        //                 <Button sx={{ color: "black" }} onClick={() => openModal(rowData)}> <VisibilityIcon /></Button>
        //             );
        //         },
        //     }
        // },

        {
            name: "Download",
            label: "View Receipt",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, { rowIndex }, tableMeta) => {

                    return (
                        <Button type="button" sx={{ color: "black" }}
                        // onClick={() => handleNavigate("/fundtransfer/transactionreceipt", atmMasterList[rowIndex] ,selectedAccountName)}
                        onClick={()=>openModalReciept( atmMasterList[rowIndex])}
                        
                        >
                        <ReceiptLongIcon/>
                      </Button>
                    
                    );
                },
            }
        },

        {
            name: "transactiondate",
            label: "Transaction Date",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value) => {
                    if (!value) return ''; // If no value, return empty string

                    // Format the date with toLocaleString in 'en-GB' format
                    const formattedDate = new Date(value).toLocaleString('en-GB', {
                        day: '2-digit',          // Day in two-digit format
                        month: 'short',          // Month as a 3-letter abbreviation (e.g., "Mar")
                        year: 'numeric',         // Full year (e.g., "2025")
                        hour: '2-digit',         // Hour in two-digit format (24-hour)
                        minute: '2-digit',       // Minute in two-digit format
                        second: '2-digit',       // Second in two-digit format
                        hour12: false            // Ensure 24-hour format (no AM/PM)
                    });

                    return formattedDate;  // Return the formatted date
                }
            }
        },

        {
            name: "transType",
            label: "Transaction Type",
            options: {
                filter: true,
                sort: false,
                // customBodyRender: (value, { rowData }, tableMeta) => {
                //     return value == "INTERNAL" ? "WITHIN BANK" : value
                // },
            }
        },
        {
            name: "remAccno",
            label: "Remitter A/C No",
            options: {
                filter: true,
                sort: false,
            }
        },

        {
            name: "benAccno",
            label: "Beneficiary A/C No",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "benIfsccd",
            label: "Beneficiary IFSC",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "benName",
            label: "Beneficiary Name",
            options: {
                filter: true,
                sort: false,
                // display: false
            }
        },
        {
            name: "amount",
            label: "Transaction Amount",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value) => {
                    return <div style={{ textAlign: "right" }}>
                         {numberCommaFormat(value)}
                    </div>;
                },
            }
        },

        {
            name: "cbsrrn",
            label: "RRN",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "responseCode",
            label: "Response Code",
            options: {
              filter: true,
              sort: false,
              customBodyRender: (value,tableMeta) => {
                const rowIndex = tableMeta.rowIndex;
                const rowData = tableMeta.tableData[rowIndex];
                const transType = rowData[2]; // assuming column index 2 is `transType`
                const responseCode = value;
          
                const isNEFTorIMPSorRTGS = ["NEFT", "IMPS", "RTGS"].includes(transType);
          
                let status = "Fail";
                let color = "red";
          
                if (isNEFTorIMPSorRTGS && responseCode === "300") {
                  status = "Success";
                  color = "green";
                } else if (isNEFTorIMPSorRTGS && responseCode === "00") {
                  status = "Initiated";
                  color = "orange";
                } else if (transType === "INTERNAL" && responseCode === "00") {
                  status = "Success";
                  color = "green";
                }
          
                return <span style={{ color, fontWeight: 600 }}>{status}</span>;
              },
            }
          },
          
          
        {
            name: "responseDesc",
            label: "Response Desc",
            options: {
                filter: true,
                sort: false,
            }
        },

    ];


    const ResponseResult = [
        {
            code: "ALL",
            value: "ALL",
        },
        {
            code: "IMPS",
            value: "IMPS",
        },
        {
            code: "INTERNAL",
            value: "WITHIN BANK",
        },
        {
            code: "NEFT",
            value: "NEFT",
        },
        {
            code: "RTGS",
            value: "RTGS",
        },

    ];
    const handleLogout = () => {
        dispatch(logout());
        sessionStorage.clear()
        localStorage.clear()
        navigate("/auth/login")
    };

    const create = () => {
        navigate("/accounts/accountadd")
    };

    const updatedUserList = [allOption, ...banksCode];
    useEffect(() => {
        setUserName(sessionStorage.getItem("username"));
        setToken(sessionStorage.getItem("TOKEN"));
    }, []);

    // useEffect(() => {
    //     if ((initialLoad && ResponseResult.length > 0)) {
    //         setValue(
    //             "transtype",
    //             ResponseResult
    //                 ? compareTextAndReturnObject(ResponseResult, ResponseResult[0]?.value)
    //                 : ""
    //         );
    //         setInitialLoad(false);
    //     }
    // }, [initialLoad, ResponseResult]);





    console.log(message);


    // useEffect(() => {
    //   getTransactionListView(1, payloadData);
    // }, []);
console.log("User = ",user)

    // const accNo = watch("accNo");
    console.log("user", user);
    const accountList =
        user?.accountDetails &&
        user?.accountDetails?.map((item) => ({
            code: item.brCode,
            value: item.accNo,
            // value: item.virtualAccNo,
            name: item.name,
            acctype: item.acctype,
        }));
        console.log("accountList",accountList)

    // useEffect(() => {
    //     if (accNo) {
    //         const account = accountList.find(
    //             (acc) => acc.value === watch("accNo").value
    //         );
    //         if (account) {
    //             setSelectedAccountName(account.name);
    //             setValue("acctype", account.acctype);
    //             setValue("accName", account.name); // Optional: keep form state in sync
    //         }
    //     }
    // }, [watch("accNo"), accountList]);

    const closeSignModal = () => {
        setIsModalOpen(false);
    };

    const filteredData = bankNamee && bankNamee
        ?.filter(item => item.hasOwnProperty('companyName'))
        ?.map(item => ({ "code": item.companyId, "value": item.companyName }))

    const result = [allOption, ...filteredData];

    // useEffect(() => {
    //     if (accountList) {
    //         setValue("accNo", accountList ? compareTextAndReturnObject(accountList, accountList[0]?.value) : '')
    //     }
    // }, []);


    // const onSubmit = (data) => {

      
    //     getTransactionList(1);

    // };


   const getTransactionList = (currentpages, payloadDatachild) => {
        getTransactionListView(currentpages, payloadDatachild);
        setPayloadData(payloadDatachild);
    };

    const getTransactionListView = async (currentPage,data = payloadData) => {
        setCurrentPage(currentPage);
        setIsloading(true);
        try {

         const url = `${apiList.TRANSACTIONBROWSE}?pageNo=${currentPage}&pageSize=${goPageNumber}`;
        const response = await postApiData(url,data);

            if (response?.status == true) {
                setAtmMasterList(response?.data?.translist);
                setReceiptData(response?.data);
                settotalRecord(response?.data?.totalRecords);
                closeModalFilter();
            } else {
                setAtmMasterList([]);
                settotalRecord(0);
                SweetAlertPopup(response?.message, "Error", "error");
            }
            setIsloading(false);
        } catch (err) {
            console.log(err);
            setIsloading(false);
        }
    };


 
    const ColorButton = styled(Button)(({ theme }) => ({
        // color: "#FFFFFF",
        color: "#000000",
        // backgroundColor: "#F84B67",
        // backgroundColor: "#323232",
        backgroundColor: "#fff",
        border: "1px solid #000",
        borderRadius: "8px",
        paddingLeft: "15px",
        paddingRight: "15px",
        width: "183px",
        height: "38px",
        "&:hover": {
            background: "#808080",
            color: "white",
        },
    }));



    const ColorButton1 = styled(Button)(({ theme }) => ({
        color: "#fff",
        // backgroundColor: "#F84B67",
        backgroundColor: "var(--button-color)",
        border: "1px solid #CCC",
        borderRadius: "8px",
        paddingLeft: "15px",
        paddingRight: "15px",
        width: "183px",
        height: "38px",
        "&:hover": {
            background: "var(--button-hover-color)",
            color: "white",
        },
    }));

    const options = {
        textLabels: {
            body: {
                noMatch: (
                    <div
                        style={{
                            display: "flex",
                            height: "30vh",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: "larger"
                        }}
                    >
                        {message ? message : "Sorry, no matching records found"}
                    </div>
                ),
            },
        },
        filterType: "dropdown",
        responsive: "standard",
        filter: true,
        download: false,
        print: false,
        // checkbox:false,
        selectableRows: false,
        customFooter: () => {
            return (
                <GridTablePagination
                    currentPage={currentPage}
                    totalCount={totalRecord}
                    pageSize={goPageNumber}
                    onPageChange={(page) => {
                        console.log("page", page)
                        getTransactionListView(page)
                    }} />
            );
        },
    };
console.log("filterData",filterData)
        const CompanyformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.accNo) {
      activeFilters.push(`Account No.: ${filterData.accNo}`);
    }
    if (filterData.fromDt) {
      activeFilters.push(`From Date: ${filterData.fromDt}`);
    }
    if (filterData.toDt) {
      activeFilters.push(`To Date: ${filterData.toDt}`);
    }


    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

    return (
        <>
            {isLoading ? (<Loader loading={true} />) : (<Loader loading={false} />)}
            <Box
                className={classes.mainContainer}
                // component="form"

                // onSubmit={handleSubmit(onSubmit)}
            >
                <div className={classes.Sbox}>
                    <div className={`${classes.bluerow} ${theme === "dark" ? `${classes.DarkTheme}` : `${classes.LightTheme}`}`}>
                        <div className={classes.bluerowtext}>Transfer History</div>
                        {/* <div style={{ display: "flex", gap: "10px" }}></div> */}
                          <div className={classes.filterContainer}>
    {showFilters && (
      <motion.div
        initial={{ x: "100%", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: "100%", opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <div className={classes.searchBtn} 
        onClick={openModalFilter}
        >
          Search/Filter
        </div>
      </motion.div>
    )}

    {showFilters && (
      <motion.div
        initial={{ x: "100%", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: "100%", opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <div className={classes.greenBtn}
         onClick={handleToggle}
        //  onClick={fetchData}
         >
          <CachedIcon />
        </div>
      </motion.div>
    )}

    <div className={classes.filterBoggleBox}>
        <Tooltip title="Filter Options" arrow placement="bottom">
      <img
        src={FilterImg}
        alt="funnel"
        className={classes.funnelIcon}
        onClick={toggleFilters} />
        </Tooltip>
      <div
  className={`${classes.filterText} ${filterData && Object.keys(filterData).length > 0 ? "pr-1" : ""}`}
>

      {filterData && CompanyformatFilterDisplay(filterData)}
      </div>
    </div>
  </div>
                    </div>
                   
                    <div className={classes.parentcomp}>
                        <div className={classes.Sbox2}>
                            {/* <div className={classes.bluerow}>UPI Transaction List</div> */}
                            <div style={{ width: "100%", marginBottom: "10px" }}>
                                <MUIDataTable
                                    // title={" Transaction Report"}
                                    data={atmMasterList}
                                    columns={columns}
                                    options={options}
                                />
                            </div>
                        </div>
                        {/* 
            {isModalOpen ? (
              <TransactionView
                open={isModalOpen}
                handleClose={closeModal}
                closeSignModal={closeSignModal}
                rowDataToDisplay={rowDataToDisplay}
                show={"2"}
                title={"Transaction Report"}
              />
            ) : null} */}

                    </div>
                </div>

            </Box>

             {isModalOpenFilter ? (
          <TxnFilterModal
            show={isModalOpenFilter}
            handleClose={closeModalFilter}
            accountList={accountList}
            getTransactionList={getTransactionList}
            setFilterData={setFilterData}
            setSelectedAccountName={setSelectedAccountName}
            selectedAccountName={selectedAccountName}
          />
        ) : null}
        
             {isModalOpenReciept ? (

               <TransactionReceipt
            isOpen={isModalOpenReciept}
            onClose={closeModalReciept}
          responseData={responseData}
          selectedAccountName={selectedAccountName}
          />
        ) : null}

        </>
    );
};

export default TransactionBrowse;
